import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {CustomDollarAmountComponent} from '../custom-dollar-amount/custom-dollar-amount.component';
import {subtractCurrency} from '../../_utils/currency-math';
import {Organization} from '../../_models/organization';
import {OrganizationService} from '../../_services/organization.service';
import {DonationProgram} from '../../_models/donation-program';

@Component({
    selector: 'bb-donation',
    templateUrl: './donation.component.html',
    styleUrls: ['./donation.component.scss']
})
export class DonationComponent implements OnChanges, OnInit {
    @Input() donation: number;
    @Input() maxDonation: number;
    @Input() tabTotal: number;
    @Input() donationProgram: DonationProgram;
    @Output() donationChange = new EventEmitter<number>();

    organization: Organization;
    selectedDonation: any;
    roundDonation: number;
    presets = [];
    donationValue: number;
    xsCol = 6;
    medCol = 6;

    constructor(
        private organizationService: OrganizationService,
        private modalController: ModalController
    ) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ((!!changes.tabTotal && !changes.tabTotal.isFirstChange())
            || (!!changes.max && !changes.max.isFirstChange())) {
            this.getPresets();
        }
    }

    ngOnInit(): void {
        this.organization = this.organizationService.currentValue;
        this.getPresets();
    }

    calculateRoundUp() {
        if (!!this.tabTotal && this.tabTotal.toString().indexOf('.') > -1) {
            const split = this.tabTotal.toString().split('.');
            const cents = Number.parseFloat('.' + split[1]);
            if (cents > 0) {
                this.roundDonation = subtractCurrency(1, cents);
            } else {
                this.roundDonation = 1;
            }
        } else {
            this.roundDonation = 1;
        }
    }

    getPresets() {
        this.calculateRoundUp();
        this.presets = [];
        const presets = !!this.donationProgram && !!this.donationProgram.presets
            ? this.donationProgram.presets.split(',')
            : [];

        presets.forEach(p => this.presets.push(Number.parseFloat(p)));

        const buttonCount = this.presets.length;

        if (buttonCount === 1) {
            this.xsCol = 12;
            this.medCol = 12;
        } else if (buttonCount === 2) {
            this.xsCol = 6;
            this.medCol = 6;
        } else if (buttonCount === 3) {
            this.xsCol = 4;
            this.medCol = 4;
        } else if (buttonCount === 4) {
            this.xsCol = 6;
            this.medCol = 3;
        } else if (buttonCount === 5) {
            this.xsCol = 6;
            this.medCol = 4;
        }

        if (this.roundDonation === this.donation) {
            this.selectedDonation = 'ROUND_UP';
        } else if (this.donation > 0 && !this.presets.some(p => p === this.donation)) {
            this.selectedDonation = 'CUSTOM';
        } else {
            this.selectedDonation = this.donation;
        }
    }

    async clickCustom() {
        this.selectedDonation = 'CUSTOM';
        const modal = await this.modalController.create({
            component: CustomDollarAmountComponent,
            componentProps: {
                max: this.maxDonation,
                amount: '',
                label: `${this.donationProgram.name} Donation`
            },
            breakpoints: [0.0, 1],
            initialBreakpoint: 1,
            cssClass: 'quick-input-modal'
        });
        await modal.present();

        modal.onDidDismiss().then(async (returnData) => {
            if (!!returnData && (!!returnData.data || returnData.data === 0)) {
                this.donationValue = Number.parseFloat(returnData.data);
                this.donationChange.emit(this.donationValue);
            }
        });
    }

    changedSelected(selection: number | string) {
        this.selectedDonation = selection;
        if (this.selectedDonation === 'NO_DONATION') {
            this.donationValue = 0;
            this.donationChange.emit(0);
        } else if (this.selectedDonation === 'ROUND_UP') {
            this.donationChange.emit(this.roundDonation);
        } else {
            this.donationChange.emit(selection as number);
        }
    }

    manualEntry() {
        this.selectedDonation = null;
    }
}
